var exports = {
  "nM": "ComparisonRow.module__row___TnpzQm",
  "N4": "ComparisonRow.module__feature___TnpzQm",
  "oo": "ComparisonRow.module__featureText___TnpzQm",
  "a7": "ComparisonRow.module__valuesContainer___TnpzQm",
  "dY": "ComparisonRow.module__restrictedValue___TnpzQm",
  "ge": "ComparisonRow.module__stockValue___TnpzQm",
};

module.exports = exports;
